import React from 'react';
import { useNavigate } from 'react-router-dom';
import User from "../../../Auth/User";
import styles from './NeedLogin.module.scss';
import screenshot from "../../../../assets/screenshot.png";
import useTheme from "@mui/material/styles/useTheme";
import { useUserContext } from "../../../../contexts/UserContext";

export const NeedLogin = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const { username } = useUserContext();
  const navigate = useNavigate();

  return (
    <div className={`${styles.needLoginContainer} ${isDarkMode ? styles.darkMode : styles.lightMode}`}>
      <div className={styles.contentWrapper}>
        <div className={styles.heroSection}>
          <div className={styles.badge}>Now Live!</div>
          <h1 className={styles.needLoginTitle}>
            <span className={styles.gradient}>Crossover Live</span>
          </h1>
          <p className={styles.subtitle}>
            Real-time multiplayer sports trivia battles
          </p>
          <p className={styles.needLoginText}>
            Challenge opponents in live unlimited tic-tac-toe grids across NBA, NFL, MLB, NHL, Soccer, and Movies. Test your knowledge and climb the leaderboard!
          </p>
          <div className={styles.signInButtonWrapper}>
            {username ? (
              <button
                onClick={() => navigate('/play')}
                className={styles.playButton}
              >
                Play Multiplayer
              </button>
            ) : (
              <User />
            )}
          </div>
        </div>

        <div className={styles.imageWrapper}>
          <img
            src={screenshot}
            alt="Crossover Live gameplay screenshot"
            className={styles.embedImage}
          />
        </div>

        <div className={styles.featuresGrid}>
          <div className={styles.feature}>
            <div className={styles.featureIcon}>⚡</div>
            <h3>Live Matchmaking</h3>
            <p>Instant matches with players worldwide</p>
          </div>
          <div className={styles.feature}>
            <div className={styles.featureIcon}>🏆</div>
            <h3>Competitive Play</h3>
            <p>Climb the leaderboard and track stats</p>
          </div>
          <div className={styles.feature}>
            <div className={styles.featureIcon}>🎮</div>
            <h3>Multiple Sports</h3>
            <p>7 categories of trivia challenges</p>
          </div>
          <div className={styles.feature}>
            <div className={styles.featureIcon}>♾️</div>
            <h3>Unlimited Rounds</h3>
            <p>Play as much as you want, anytime</p>
          </div>
        </div>
      </div>
    </div>
  );
};
